export function descendingComparator(a, b, orderBy) {
  const getNestedValue = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);
  
  let valA = getNestedValue(a, orderBy);
  let valB = getNestedValue(b, orderBy);

  // Handle strings for case insensitive comparison
  if (typeof valA === 'string') valA = valA.toLowerCase();
  if (typeof valB === 'string') valB = valB.toLowerCase();
  
  if (valA === undefined || valA === null) valA = '';
  if (valB === undefined || valB === null) valB = '';

  if (valB < valA) {
    return -1;
  }
  if (valB > valA) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
